import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';

const tileData = [
    {
        name:'Label'
    },
    {
        name:'Text-Input'
    },
    {
        name:'RadioBoxes'
    },
    {
        name:'Checkboxes'
    },
    {
        name:'Dropdown'
    },
    {
        name:'Paragraph'
    },
    {
        name:'Add Item'
    },
    
]

const useStyles = makeStyles(theme => ({
    root: {
      width: '10%',
      marginLeft: '7%',
    },
    headerTitle: {
        padding: 'auto',
    },
    tableTitle: {
        float: "left",
        paddingLeft: "10px",
        fontSize:'1.5em',
    },
    listItem: {
        fontSize: '2em',
    },
  }));

const ComponentBox = () =>{
    const classes = useStyles();
    function ondragstart(e,name){
        e.dataTransfer.setData("id",name);
    }
    return(
        <div className={classes.root}>
            <div className={classes.tableTitle}>
                    <h3 className={classes.headerTitle}>ToolBox</h3>
                </div>
            <List component="nav" disablePadding>
                {tileData.map(tile=>(
                    <>
                    <ListItem button >
                        <ListItemText draggable className={classes.listItem} onDragStart={(e)=>ondragstart(e,tile.name)} primary={tile.name} />
                    </ListItem>
                    <Divider component="li" />
                    </>
                ))}
                
                
            </List>
      </div>
    )
}

export default ComponentBox